import React, {useEffect, useRef, useState} from 'react';
import {
  calculateSumOfEachRowSadanJustSaleReturn,
  calculateTotalSum, calculateTotalSumReturnFromSell,
  deleteRowHandlerSadan,
  updateTableCellHandlerSadan, updateTableCellHandlerSadanByPack
} from "../SellFactorSdanaShop/SellFactorFunctionsSadan";
import tableCalc from "../../utils/tableCalc";
import {ReactTabulator} from "react-tabulator";
import tabulatorTableOptions from "../../utils/TabulatorTableOptions";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../utils/CommaSeparator";
import NewTabulator from "../NewTabulator/NewTabulator";
import numeric from "../../utils/NumericFunction";
import utilsFunction from "../../utils/utilsFunction";
import {calculateSumOfEachRow, calculateSumOfEachRowInReturnFromSale} from "../SellFactor/SellFactorFunctions";

const SaleReturnTableSadan = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {


  // const tableRef = useRef()
  const celEditHandler = cell => {
    setSendData({tableData: calculateSumOfEachRowSadanJustSaleReturn(sendData.tableData)})
  }
  // useEffect(() => {
  //   // in this section i Register cellEdited  To prevent So many Problems in Return I Off The Registered And Register Again When component Mount
  //   if (tableRef.current !== null && tableRef.current !== undefined) {
  //     if (tableRef.current.table !== null && tableRef.current.table !== undefined) {
  //       tableRef.current?.table?.on("cellEdited", celEditHandler);
  //       const css = "font-size: 22px;color:red;"
  //       console.log("%c" + "celEditHandler Registered", css);
  //       return () => {
  //         const css = "text-shadow: 1px 1px 2px black, 0 0 2px blue, 0 0 0.2em blue; font-size: 14px;"
  //         console.log("%c" + "Component unmounted or updated", css);
  //         tableRef.current?.table?.off("cellEdited", celEditHandler);
  //       }
  //     }
  //   }
  //
  //
  // }, [sendData.tableData])

  const [reload, setReload] = useState(false)

  const [sum, setSum] = useState(0);
  useEffect(() => {
    const newSum = isNaN(calculateTotalSum(sendData)) ? 0 : calculateTotalSum(sendData)
    setSum(newSum)

  }, [sendData]);


  const tableColumns = [
    {
      title: "حذف", headerSort: false, formatter: "buttonCross", // width: 60,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
      cellClick: function (e, cell) {
        //console.log("حذف حذف حذف");
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const type = cell.getData().type;
        const tableData = deleteRowHandlerSadan(sendData.tableData, productId, storeId, type);
        setSendData({tableData})
      }
    },
    {
      title: " کد انبار", field: "storeId", visible: false,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "انبار", field: "storeName", visible: true,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "کد کالا", field: 'productId', visible: true,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "نوع", field: 'typeShow', visible: true,
      // style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {
      title: "نام کالا", field: 'productName',
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: 190, maxWidth: 190},
    },
    {
      title: "گروه کالا", field: 'productGroup', visible: false,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    }, {
      title: "کد گروه", field: 'productGroupId', visible: false,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },


    {
      title: "قیمت", field: 'price', editor: "number", formatter: tableCalc.separateNumbers,

      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},

      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value)

        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const type = cell.getData().type
        let tableData = [];
        if (type === "bulk") {
          tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "price", value, type)
        } else {
          const packId = cell.getData().packId
          tableData = updateTableCellHandlerSadanByPack(sendData.tableData, productId, storeId, "price", value, packId)

        }
        tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "price", value)
        setSendData({tableData});
        setReload(!reload);

      },
    },
    {
      title: "وزن خالص", field: 'netReturnedWeight', editor: "number", formatter: tableCalc.persianDigits,
      cellEdited: function (e, cell) {
        let value = (e.target.value);
        if (value === "") {
          value = "0"
        }
        value = numeric.p2e(value)
        value = utilsFunction.LimitDotAndThreeCharsAfterDot(value)

        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const type = cell.getData().type

        if (type !== 'bulk') {
          // if there is any limitation in
          // netReturnedWeight you can add here
        }

        let tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "netReturnedWeight", value, type)
        if (type === 'bulk') {
          tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "returnedWeight", value, type)
        }

        setSendData({tableData});
        setReload(!reload);
      },
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
      bottomCalc: tableCalc.sum,
    },
    {
      title: "وزن برگشتی", field: 'returnedWeight', editor: "number", formatter: tableCalc.persianDigits,
      cellEdited: function (e, cell) {
        let value = (e.target.value)
        if (value === "") {
          value = "0"
        }
        value = numeric.p2e(value)
        value = utilsFunction.LimitDotAndThreeCharsAfterDot(value)
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const type = cell.getData().type;

        let tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "returnedWeight", value, type)
        if (type === 'bulk') {
          tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "netReturnedWeight", value, type)
        }
        setSendData({tableData});
        setReload(!reload);
      },
      style: {
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        // minWidth: 'fit-content'
      },
      bottomCalc: tableCalc.sum,
    },
    {
      title: "بازگشت به انبار", field: 'returnToStore', formatter: 'checkBox',
      cellEdited: function (e, cell) {

        const value = (e.target.checked)
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const type = cell.getData().type;
        let tableData =[];
        if(type==='bulk'){
          // if there is any limitation in
          // returnToStore you can add here
        }else {
          tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, "returnToStore", value, type)
          setSendData({tableData})
          setReload(!reload)
        }

      },
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },


    {
      title: "جمع کل", field: "total", bottomCalc: tableCalc.sum,
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
    },
    {title: "  آدی موجودی", field: "inventoryId", visible: false,},
    {title: "آدی جزء", field: "particleFactorId", visible: false,},
    {field: "recordId", visible: false,},


  ];
  // MUST BE TWO seprate useEffect To Work
  useEffect(() => {
    setSendData({tableData: calculateSumOfEachRowSadanJustSaleReturn(sendData.tableData)})
    // setSendData({tableData: calculateSumOfEachRowInReturnFromSale(sendData.tableData)})
  }, [reload]);

  //console.log(sendData)
  return (
    <div className="separate-factor__newSellComponent"
      // ref={seperateFac}
    >


      <NewTabulator
        columns={tableColumns}
        data={sendData.tableData}
        style={{height: "70vh"}}
        className={"header__color__F1F1F1"}
      />
      <div> جمع کل : {formatToPersianAddComma(sum)}</div>

    </div>
  );
};

export default SaleReturnTableSadan;
